export const NEWS_DATE_FORMAT = "YYYY.MM.DD"
